import { render, staticRenderFns } from "./AutocompleteTag.vue?vue&type=template&id=653923d0&scoped=true&"
import script from "./AutocompleteTag.vue?vue&type=script&lang=js&"
export * from "./AutocompleteTag.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteTag.vue?vue&type=style&index=0&id=653923d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653923d0",
  null
  
)

export default component.exports